import { render } from "./ChatAudio.vue?vue&type=template&id=fa6de9ee"
import script from "./ChatAudio.vue?vue&type=script&lang=js"
export * from "./ChatAudio.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__